export function sortShortcut(shortcut: string): string {
    const shortcutArray = shortcut.split(' ');
    shortcutArray.sort(function (a, b) {
        if (a > b) {
            return -1;
        }
        if (b > a) {
            return 1;
        }
        return 0;
    });
    const sortedShortcut = shortcutArray.join(' ');
    return sortedShortcut;
};
